import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "redux/actions/Index";
import PlanCreationPage from "components/pages/planCreation/PlanCreationPage";
import { RootState } from "redux/reducers/RootReducer";
import { IPlanCreation } from "interfaces/Index";

export const mapStateToProps = (state: RootState, props: any): any => {
  const {
    riderManagement: {
      isCsvDownloaded,
      locusCsvFile,
      isLoading,
      isError,
      error,
    },
    product: { wareHouseNames },
  } = state;
  return {
    isLoading,
    isError,
    error,
    wareHouseNames,
    isCsvDownloaded,
    locusCsvFile,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    getWarehouseNamesForPlanCreation: () =>
      dispatch(actions.fetchWareHouseNames()),
    downloadLocusCsv: (payload: IPlanCreation) =>
      dispatch(actions.downloadLocusCsvAction(payload)),
    downloadPlanOutputCsv: (planId: string) =>
      dispatch(actions.downloadPlanOutputCsvAction(planId)),
  };
};

const PlanCreationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanCreationPage);
export default PlanCreationContainer;
